import React from 'react';
import { FormView } from '../../components/base/FormView';
import { FlowForm } from './FlowForm';
import { CloseOutlined } from '@ant-design/icons';
const FlowEditor = ({ flow, onCreate, onUpdate, onClose, onTest, isEditing, style, }) => {
    const displayMapping = {
        name: 'Name',
        description: 'Description',
        step_slugs: 'Steps',
        steps: 'Steps',
    };
    const handleClose = () => {
        onClose();
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: "flex-row", style: { justifyContent: 'flex-end' } },
            React.createElement(CloseOutlined, { onClick: handleClose })),
        React.createElement("div", { className: "flex-column", style: { paddingTop: 12 } },
            React.createElement(FormView, { headerForm: flow.name, data: flow, displayMapping: displayMapping, onUpdate: onUpdate, onCreate: onCreate, onTest: onTest, isLoading: false, customForm: React.createElement(FlowForm, { entity: flow }), isEditingForm: isEditing, style: style }))));
};
export default FlowEditor;
